<template>
  <div id="app">
    <div id="fullscreen">
      <router-view/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    created() {
      this.$store.dispatch('init', this.$store)
    }
  }
</script>

<style>
  #app {
    font-family: 'Sukhumvit Set', 'Thai Sans Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    height: 100%;
    margin: 0;
  }

  #fullscreen {
    background-color: #4DC4FF;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
  }
</style>
